module.exports = __webpack_public_path__ + "static/media/companyLogo.e637ad47.png";